var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 121,
    viewBox: "0 0 203 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.932 110.299L158.61 115.306V105.264L149.932 110.299Z",
    fill: "#D11116"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.699 112.459L189.455 110.297L185.699 108.106V112.459Z",
    fill: "#D11116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4466 120.314L104.804 110.3L87.4466 100.257V120.314Z",
    fill: "#D11116"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6042 83.2424L114.478 92.9722V73.5127L97.6042 83.2424Z",
    fill: "#D11116"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.274 89.8432L147.713 83.2429L136.274 76.6426V89.8432Z",
    fill: "#D11116"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.776 83.2433L202.971 83.9261V82.5605L201.776 83.2433Z",
    fill: "#D11116"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7409 110.299L67.6143 120.029V100.541L50.7409 110.299Z",
    fill: "#D11116"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1578 64.9773L103.381 56.1864L88.1578 47.3955V64.9773Z",
    fill: "#D11116"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.839 56.1871L157.644 59.5442V52.8301L151.839 56.1871Z",
    fill: "#D11116"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.467 57.0124L187.918 56.1873L186.467 55.3623V57.0124Z",
    fill: "#D11116"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0947 92.3465L56.8867 83.2427L41.0947 74.1104V92.3465Z",
    fill: "#D11116"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9929 56.1877L66.9883 64.8364V47.5391L51.9929 56.1877Z",
    fill: "#D11116"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.296 29.1312L111.604 33.9392V24.3232L103.296 29.1312Z",
    fill: "#D11116"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.522 31.8332L143.217 29.1305L138.522 26.4277V31.8332Z",
    fill: "#D11116"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.7534 114.167L3.99023 110.298L-2.7534 106.4V114.167Z",
    fill: "#D11116"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02638 83.2418L18.1602 88.505V77.9502L9.02638 83.2418Z",
    fill: "#D11116"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6266 33.8526L51.8213 29.13L43.6266 24.3789V33.8526Z",
    fill: "#D11116"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.562 2.07683L63.2041 4.15363V0L59.562 2.07683Z",
    fill: "#D11116"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0279 4.15363L95.6416 2.07683L92.0279 0V4.15363Z",
    fill: "#D11116"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.89964 58.604L2.31152 56.1858L-1.89964 53.7676V58.604Z",
    fill: "#D11116"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5266 29.1323L16.4248 31.3513V26.8848L12.5266 29.1323Z",
    fill: "#D11116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcn);
export default __webpack_public_path__ + "static/media/serviceIcn.939bb5383d96a8c3f011bd1f48ea9fef.svg";
export { ForwardRef as ReactComponent };